<mat-expansion-panel class="expansion-panel" hideToggle (opened)="opened = true" (closed)="opened = false">
  <mat-expansion-panel-header>
    <mat-panel-title>{{ data.title }}</mat-panel-title>
    <div class="panel-header-info">
      <span *ngIf="data.points">{{ data.points }} {{creditsText}}</span>
      <mat-icon [svgIcon]="opened ? 'minus-3' : 'plus-3'" class="square-icon state-icon"></mat-icon>
    </div>
  </mat-expansion-panel-header>
  {{ data.description }}
  <div class="content-footer">
    <div class="teacher">{{ data.teacher }}</div>
    <a *ngIf="data.viewLink" [href]="data.viewLink" target="_blank">{{linkTitle}}</a>
  </div>
</mat-expansion-panel>
